import { d as l, _ as t } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as c, createElementBlock as s, normalizeClass as r, normalizeStyle as n, createTextVNode as a, createElementVNode as o } from "vue";
const i = l("s-follow"), p = /* @__PURE__ */ o("path", {
  d: "M1113.6 349.867h-128c0-119.467-98.133-217.6-217.6-217.6-55.467 0-106.667 21.333-149.333 59.733l-4.267 4.267c-34.133 34.133-85.333 34.133-119.467 0-42.666-42.667-93.866-64-149.333-64-119.467 0-217.6 98.133-217.6 217.6H0c0-192 153.6-345.6 345.6-345.6 76.8 0 149.333 25.6 209.067 72.533C614.4 29.867 686.933 4.267 763.733 4.267c196.267 0 349.867 153.6 349.867 345.6zM588.8 102.4zM93.867 631.467c-4.267-4.267-8.534-12.8-12.8-17.067-51.2-76.8-76.8-170.667-76.8-260.267h128c0 68.267 21.333 136.534 55.466 192 4.267 0 4.267 4.267 8.534 8.534l-102.4 76.8zm934.4-8.534L921.6 550.4c38.4-59.733 64-128 64-200.533h128c0 98.133-29.867 192-85.333 273.066z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), f = /* @__PURE__ */ o("path", {
  d: "M558.933 989.867c-12.8 0-29.866-4.267-42.666-8.534-4.267-4.266-8.534-4.266-12.8-4.266C332.8 900.267 192 776.533 85.333 622.933L192 554.667c89.6 136.533 217.6 243.2 362.667 307.2l4.266-4.267C704 789.333 832 682.667 921.6 550.4l106.667 72.533c-102.4 153.6-247.467 277.334-418.134 354.134l-8.533 4.266c-12.8 8.534-29.867 8.534-42.667 8.534zM550.4 866.133zm17.067 0z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1);
function m(e, d, _, h, z, u) {
  return c(), s("svg", {
    class: r(e.classes),
    style: n(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1113 1024",
    role: "presentation"
  }, [
    p,
    a(","),
    f
  ], 6);
}
const y = /* @__PURE__ */ t(i, [["render", m]]);
export {
  y as default
};
